module.exports = __webpack_public_path__ + "img/QIANXIN.5423fd68.png";